export function setupProducts(selector = '.products') {
    if (!window.matchMedia('(any-hover: hover)').matches) return;

    document.querySelectorAll(selector).forEach(module => {
        module.querySelectorAll('.products__item').forEach(item => {
            const textWrap = item.querySelector('.products__item-text-wrap');
            if (!textWrap) return;

            item.addEventListener('mouseenter', () => {
                textWrap.style.height = `${textWrap.scrollHeight}px`;
            });

            item.addEventListener('mouseleave', () => {
                textWrap.style.height = '0';
            });
        });
    });
}
